import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import './stories-card.scss';
import icon_open from '../../assets/icons/ico_open.svg';

const titleStyle = {
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	color: '#000000',
};

const StoryCardLink = ({ slug, storyLink, storiesList }) => {
	const StoryCardContent = (
		<Fragment>
			<div className="company-icon black">
				{storiesList && (
					<img
						src={`${process.env.REACT_APP_API_ENDPOINT
							+ storiesList.partner.blackLogo.path}`}
						alt={storiesList.partner.label}
					/>
				)}
			</div>
			<div className="company-icon white">
				{storiesList && (
					<img
						src={`${process.env.REACT_APP_API_ENDPOINT
							+ storiesList.partner.whiteLogo.path}`}
						alt={storiesList.partner.label}
					/>
				)}
			</div>
			<div className="category">
				<span>{storiesList.category.id}</span>
			</div>
			<div style={titleStyle} className="story-title">
				<span>{storiesList.title}</span>
			</div>
		</Fragment>
	);

	return storyLink ? (
		<a className="card-link" href={`//${storyLink}`} target="_blank" rel="noreferrer noopener">
			{StoryCardContent}
		</a>
	) : (
		<Link className="card-link" to={`/stories/${slug}`}>
			{StoryCardContent}
		</Link>
	);
};

const StoriesCard = ({ storiesList, intl }) => (
	<div
		className={cn('col-xs-12 col-md-4 stories-card fade-in', {
			noImage: !storiesList.Image.path,
		})}
	>
		<div className="hoverImg">
			{storiesList.Image.path && (
				<img
					src={`${process.env.REACT_APP_API_ENDPOINT + storiesList.Image.path}`}
					alt={storiesList.Image.label}
				/>
			)}
		</div>
		<div className="link-wrapper">
			<StoryCardLink
				slug={storiesList.slug}
				storyLink={storiesList.storyLink}
				storiesList={storiesList}
			/>

			<div className="read-more">
				{storiesList.storyLink && storiesList.storyLink ? (
					<a
						className="external-link"
						href={`//${storiesList.storyLink}`}
						target="_blank"
						rel="noreferrer noopener"
					>
						{intl.formatMessage({
							id: 'stories.card.read.more',
						})}
						<img src={icon_open} alt="open" />
					</a>
				) : (
					<Link className="read-link" to={`/stories/${storiesList.slug}`}>
						{intl.formatMessage({
							id: 'stories.card.read.more',
						})}
					</Link>
				)}
			</div>
		</div>
	</div>
);

export default withRouter(injectIntl(StoriesCard));
